export default __webpack_public_path__ + "static/media/Frame 19.0290bb5a.png";